import { render, staticRenderFns } from "./addCustomer.vue?vue&type=template&id=f088cb2e&scoped=true&"
import script from "./addCustomer.vue?vue&type=script&lang=js&"
export * from "./addCustomer.vue?vue&type=script&lang=js&"
import style0 from "./addCustomer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./addCustomer.vue?vue&type=style&index=1&id=f088cb2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f088cb2e",
  null
  
)

export default component.exports